import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'bil-bureau-term-condition',
  templateUrl: './bureau-term-condition.component.html',
  styleUrls: ['./bureau-term-condition.component.sass']
})
export class BureauTermConditionComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<BureauTermConditionComponent>) { }

  ngOnInit() {
  }

  closeModal() {
    this.dialogRef.close();
  }

}
